export default {
    GET_SIGNLE_ITEM: 'fetch/{object}/{id1}/{id2}',
    CREATE_ITEM: 'create/{object}',
    DELETE_ITEM: 'delete/{object}',
    UPDATE_ITEM: 'update/{object}',
    ACTION_UNAUTH: 'actionunauth/{actionName}',
    ACTION: 'action/{actionName}',
    GET_LIST: 'fetch/{object}/{id1}/{id2}',
    GET_BLOG: 'https://techpearl.com/wp-json/wp/v2/posts',
    GET_QUOTES: 'https://api.quotable.io/random?tags=technology'
} as const;